import { render, staticRenderFns } from "./MenuBarItems.vue?vue&type=template&id=4099dfae&scoped=true"
import script from "./MenuBarItems.vue?vue&type=script&lang=js"
export * from "./MenuBarItems.vue?vue&type=script&lang=js"
import style0 from "./MenuBarItems.vue?vue&type=style&index=0&id=4099dfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099dfae",
  null
  
)

export default component.exports